import Vue from 'vue'

const USER_STATE_CHANGED_EVENT = 'user-state-change'
const HUNT_AREA_MEMBERS_CHANGED_EVENT = 'hunt-area-members-change'
const HUNT_MEMBERS_CHANGED_EVENT = 'hunt-members-change'
const GPS_OWNER_CHANGED_EVENT = 'gps-owner-change'
const GPS_SUBSCRIPTION_CHANGED_EVENT = 'gps-subscription-change'

const eventManager = new Vue()

export {
  eventManager,
  USER_STATE_CHANGED_EVENT,
  HUNT_AREA_MEMBERS_CHANGED_EVENT,
  HUNT_MEMBERS_CHANGED_EVENT,
  GPS_OWNER_CHANGED_EVENT,
  GPS_SUBSCRIPTION_CHANGED_EVENT
}
